import { StylesValue } from "../contexts/styles";
import { useContext } from "react";

export default function () {
  const styles = useContext(StylesValue);

  const set = (tree) => {
    if (!tree) {
      return tree;
    }
    if (tree.style) {
      const style = styles.find((x) => x.id === tree.style);
      if (style) {
        Object.keys(style.props).forEach((k) => {
          tree.props[k] = style.props[k];
        });
      }
    }

    if (tree.children.length > 0) {
      tree.children = tree.children.map((c) => set(c));
    }

    return tree;
  };

  return set;
}
